export default "__VITE_ASSET__CK42fj1J__"